import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InspectionState } from '../classes/inspectionState';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class InspectionStateService {
    API_INSPECTION_STATE_URL = config.serverAddress + ':' + config.serverPort + '/inspection-state/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_INSPECTION_STATE_URL + 'all');
    }
    getByID(id: string) {
        return this.http.get(this.API_INSPECTION_STATE_URL + id);
    }
    create(inspectionState: InspectionState) {
        return this.http.post(this.API_INSPECTION_STATE_URL + 'create', inspectionState);
    }
    update(inspectionState: InspectionState) {
        return this.http.put(this.API_INSPECTION_STATE_URL + 'update', inspectionState);
    }
    delete(id: number) {
        return this.http.delete(this.API_INSPECTION_STATE_URL + 'delete/' + id);
    }
}